export const JTBD_CONTAINER_WIDTH = 1412;
